module.exports = __webpack_public_path__ + "media/images/move-activity-80fe2b9d.svg";